import m3u8Video from '@/components/m3u8VideoH265';
export default {
  components: {
    m3u8Video: m3u8Video
  },
  data: function data() {
    return {
      id: ''
    };
  },
  mounted: function mounted() {
    this.id = this.$route.query.id;
  },
  methods: {}
};